<template>
  <div class="order-record">
    <div class="main">
      <!-- Title -->
      <div class="title_bar">
        <div class="left">
          <div class="title">
            {{ $t('OrderFoodRecord.TitleHistory') }}
          </div>
          <div class="tip">
            {{ $t('OrderFoodRecord.TipHistory') }}
          </div>
        </div>
      </div>
      <div class="subtitle">
        <i class="icon-filter"> </i>
        {{ $t('OrderFoodRecord.Filter') }}
      </div>

      <FilterFrame
        ref="filter"
        :filter-form="orderFoodRecordsFilter"
        @search="onSearch"
        @clear="firstSearch"
      />

      <div class="data-table__title">
        <div>
          <i class="icon-list"></i>
          <span>{{ $t('OrderFoodRecord.ListTitle') }}</span>
        </div>
        <div>
          <span class="data-table__count"> {{ `${$t('OrderFoodRecord.SearchResult')} ${totalCount} ${$t('OrderFoodRecord.SearchResultCount')}` }} </span>
          <el-button @click="exportRecord">
            {{ $t('OrderFoodRecord.Export') }}
          </el-button>
        </div>
      </div>
      <el-table :data="orderRecords">
        <el-table-column label="#" type="index" width="50" prop="index">
        </el-table-column>
        <el-table-column :label="$t('OrderFoodRecord.TableLabelHousehold')">
          <template slot-scope="scope">
            <div>
              {{ scope.row['TabletNote'] }}
            </div>
            <el-button type="danger" size="mini" round>
              {{ scope.row['PointAfter'] }}
            </el-button>
          </template>
        </el-table-column>
        <el-table-column :label="$t('OrderFoodRecord.TableLabelTradePoint')" width="100" prop="TransferPoint">
        </el-table-column>
        <el-table-column :label="$t('OrderFoodRecord.TableLabelPointType')" width="120" prop="PointName">
        </el-table-column>
        <el-table-column :label="$t('OrderFoodRecord.TableLabelTime')" prop="TransferAt">
        </el-table-column>
        <el-table-column :label="$t('OrderFoodRecord.TableLabelContent')" width="260">
          <template slot-scope="scope">
            <div v-html="formatRecords(scope.row['ReceiptRecord'])"></div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('OrderFoodRecord.TableLabelNote')" prop="Note">
        </el-table-column>
        <el-table-column :label="$t('OrderFoodRecord.TableLabelSystemUser')" prop="StoreUser">
        </el-table-column>
        <el-table-column :label="$t('OrderFoodRecord.TableLabelStatus')">
          <template slot-scope="scope">
            <span :class="scope.row['VoidStatus'] === true && 'data-table__void'" @click="scope.row['VoidStatus'] && showVoidInfo(scope.row)">
              {{ scope.row['VoidStatus'] === false ? $t('OrderFoodRecord.DoneStatus') : $t('OrderFoodRecord.VoidStatus') }}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('OrderFoodRecord.TableLabelAction')" width="200">
          <template slot-scope="scope">
            <div class="operate">
              <el-tooltip
                v-if="!scope.row['OperationStatus'] && !scope.row['VoidStatus']"
                :content="scope.row['IsTableFoodForm'] ? $t('OrderFoodRecord.NewVersionRecordActionTip', {Action: $t('OrderFoodRecord.Void')}) : $t('OrderFoodRecord.OvertimeVoidTip')"
                placement="top"
              >
                <div>
                  <el-button
                    size="mini"
                    type="danger"
                    plain
                    :disabled="!scope.row['OperationStatus']"
                    @click="voidOrder(scope.row)"
                  >
                    {{ $t('OrderFoodRecord.Void') }}
                  </el-button>
                </div>
              </el-tooltip>

              <el-button
                v-else
                size="mini"
                type="danger"
                plain
                :disabled="!scope.row['OperationStatus']"
                @click="voidOrder(scope.row)"
              >
                {{ $t('OrderFoodRecord.Void') }}
              </el-button>
              <el-tooltip
                v-if="!scope.row['OperationStatus']"
                :content="showRePrintTooltip(scope.row)"
                placement="top"
              >
                <div>
                  <el-button
                    size="mini"
                    type="success"
                    class="reprint-btn"
                    :disabled="!scope.row['OperationStatus']"
                    @click="rePrint(scope.row)"
                  >
                    {{ $t('OrderFoodRecord.RePrint') }}
                  </el-button>
                </div>
              </el-tooltip>
              <el-button
                v-else
                size="mini"
                type="success"
                :disabled="!scope.row['OperationStatus']"
                @click="rePrint(scope.row)"
              >
                {{ $t('OrderFoodRecord.RePrint') }}
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <TableLoading :is-loading="loading" />
    </div>
    <RePrintResultDialog ref="rePrintResultDialog" path="orderFoodRecord" />
    <el-dialog
      :visible.sync="voidDialog"
      :close-on-click-modal="false"
      :lock-scroll="true"
      center
      custom-class="void-dialog"
      :show-close="false"
    >
      <template #title>
        <div class="void-dialog__header">
          <span class="void-dialog__title el-dialog__title">{{ $t('OrderFoodRecord.VoidOrderNote') }}</span>
          <el-tooltip :content="$t('OrderFoodRecord.VoidOrderTip')" placement="top">
            <i class="icon-questions-circular-button"></i>
          </el-tooltip>
        </div>
      </template>
      <el-form ref="voidFormRef" class="void-dialog__form" :model="voidForm" :rules="voidFormRules">
        <el-form-item>
          <el-select v-model="selectedNote" @change="onNoteSelectChange">
            <el-option
              v-for="item in noteTemplates"
              :key="item.Id"
              :label="item.Note"
              :value="item.Note"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          prop="noteInputValue"
        >
          <el-input v-model="voidForm.noteInputValue" type="textarea" rows="4" maxlength="100" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          round
          @click="closeVoidDialog"
        >{{ $t('General.Cancel') }}</el-button>
        <el-button
          type="primary"
          round
          @click="confirmVoid"
        >{{ $t('OrderFoodRecord.VoidNoteSubmitButton') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('OrderFoodRecord.VoidOrderConfirm')"
      :visible.sync="voidConfirmDialog"
      :close-on-click-modal="false"
      :lock-scroll="true"
      center
      custom-class="void-confirm-dialog"
      :show-close="false"
    >
      <div ref="confirmContent" class="void-confirm-dialog__content" @scroll="scrollToConfirm">
        <div class="void-confirm-dialog__note">
          <div>
            {{ $t('OrderFoodRecord.VoidOrderNote') }}
          </div>
          <div>
            {{ voidForm.noteInputValue }}
          </div>
        </div>
        <div class="void-confirm-dialog__detail">
          <div>
            {{ $t('OrderFoodRecord.VoidOrderDetail') }}
          </div>
          <div v-html="voidOrderDetail.receiptRecord">
          </div>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          round
          @click="prevStep"
        >{{ $t('OrderFoodRecord.PrevStep') }}</el-button>
        <el-button
          type="primary"
          round
          :disabled="!isScrollToBottom"
          @click="voidSubmit"
        >{{ $t('OrderFoodRecord.VoidSubmitButton') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('OrderFoodRecord.VoidResultSuccess')"
      :visible.sync="voidResultDialog"
      :close-on-click-modal="false"
      :lock-scroll="true"
      center
      custom-class="void-result-dialog"
      :show-close="false"
    >
      <div>
        <div class="void-result-dialog__message">
          <div>
            {{ $t('OrderFoodRecord.VoidResultSuccess') }}
          </div>
          <div>
            {{ $t('OrderFoodRecord.OrderHasBeenVoid') }}，{{ $t('OrderFoodRecord.TableLabelTradePoint') }}
            <span class="void-result-dialog__point">
              {{ voidOrderDetail.transferPoint }}
            </span> {{ $t('OrderFoodRecord.PointsRestoreTo') }} <span class="void-result-dialog__tablet">
              {{ voidOrderDetail.tabletNote }}
            </span>。{{ $t('OrderFoodRecord.OrderVoidReasonUpdateToRestoreTemplate') }}
          </div>
        </div>
        <div class="void-result-dialog__note">
          <div>
            {{ $t('OrderFoodRecord.VoidOrderNote') }}
          </div>
          <div>
            {{ orderResult.note }}
          </div>
        </div>
        <div class="void-result-dialog__detail">
          <div>
            {{ $t('OrderFoodRecord.VoidOrderDetail') }}
          </div>
          <div v-html="orderResult.detail">
          </div>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          round
          @click="closeVoidResultDialog"
        >{{ $t('General.OK') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :title="$t('OrderFoodRecord.VoidInfoTitle')"
      :visible.sync="voidInfoDialog"
      :close-on-click-modal="false"
      :lock-scroll="true"
      center
      custom-class="void-info-dialog"
      :show-close="false"
    >
      <div>
        <div class="void-info-dialog__user">
          <div>
            {{ $t('OrderFoodRecord.VoidInfoUser') }}
          </div>
          <div v-html="voidInfo.voidUser">
          </div>
        </div>
        <div class="void-info-dialog__time">
          <div>
            {{ $t('OrderFoodRecord.VoidInfoTime') }}
          </div>
          <div>
            {{ voidInfo.voidAt }}
          </div>
        </div>
        <div class="void-info-dialog__note">
          <div>
            {{ $t('OrderFoodRecord.VoidInfoNote') }}
          </div>
          <div>
            {{ voidInfo.voidNote }}
          </div>
        </div>
        <div class="void-info-dialog__detail">
          <div>
            {{ $t('OrderFoodRecord.VoidInfoDetail') }}
          </div>
          <div v-html="voidInfo.receiptRecord">
          </div>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          round
          @click="closeVoidInfoDialog"
        >{{ $t('General.OK') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
  <script>
import dayjs from 'dayjs'
import TableLoading from '@/components/TableLoading'
import FilterFrame from '@/components/FilterFrame.vue'
import { apiOrderFood } from '@/api/point/orderFood.js'
import { apiOrderFood as apiOrderFoodNew } from '@/api/OrderFood'
import { printThermalPrinter } from '@/js/utils/epos.js'
import { apiPoint } from '@/api/point/point.js'
import RePrintResultDialog from './components/RePrintResultDialog'
import { convertKeysToPascalCase } from '@/js/utils/bff'
export default {
  components: {
    FilterFrame,
    RePrintResultDialog,
    TableLoading
  },
  data () {
    const orderRecords = []
    return {
      filter: {},
      isScrollToBottom: false,
      loading: false,
      maxCount: 10,
      voidForm: {
        noteInputValue: ''
      },
      voidFormRules: {
        noteInputValue: [
          {
            type: 'string', required: true, message: this.$t('OrderFoodRecord.VoidNoteRequired'), trigger: ['change', 'blur']
          },
          {
            validator: (rule, value, callback) => {
              if (!value || value.trim() === '') {
                callback(new Error(this.$t('OrderFoodRecord.VoidNoteRequired')))
              } else {
                callback()
              }
            },
            trigger: ['change', 'blur']
          }
        ]
      },
      noteTemplates: [],
      offset: 0,
      orderFoodRecordsFilter: [],
      orderRecords,
      orderResult: {},
      printersWithStatusAndResult: [],
      scrollEnd: false,
      selectedNote: null,
      totalCount: 0,
      voidConfirmDialog: false,
      voidDialog: false,
      voidInfo: {
        receiptRecord: [],
        voidNote: '',
        transferAt: '',
        voidUser: ''
      },
      voidInfoDialog: false,
      voidOrderDetail: {
        receiptRecord: [],
        id: null,
        transferPoint: null,
        tabletNote: null
      },
      voidResultDialog: false
    }
  },
  async mounted () {
    try {
      this.firstSearch()
      this.getVoidNoteTemplates()
      const systemUsersRes = await apiOrderFood.getSystemUserList()
      const systemUsers = systemUsersRes.data.Data.Staffs.map(user => {
        return {
          key: user.AdminId,
          label: user.AdminName,
          value: user.AdminName
        }
      })
      const today = new Date()
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)

      this.orderFoodRecordsFilter = [
        {
          label: this.$t('OrderFoodRecord.FilterLabelDate'),
          name: 'date',
          type: 'dateOrMonthPicker',
          value: {
            date: [firstDayOfMonth, today],
            radio: '1'
          },
          options: [
            {
              label: this.$t('OrderFoodRecord.FilterByDate'),
              value: '1'
            }, {
              label: this.$t('OrderFoodRecord.FilterByMonth'),
              value: '2'
            }
          ]
        },
        {
          label: this.$t('OrderFoodRecord.FilterLabelHousehold'),
          name: 'household',
          type: 'house',
          value: ''
        },
        {
          label: this.$t('OrderFoodRecord.FilterLabelSystenUser'),
          name: 'user',
          type: 'select',
          clearable: true,
          value: '',
          options: systemUsers
        },
        {
          label: this.$t('OrderFoodRecord.FilterLabelPointType'),
          name: 'pointType',
          type: 'radio',
          value: '',
          options: [
            {
              label: this.$t('OrderFoodRecord.FilterPointTypeNormal'),
              value: false
            }, {
              label: this.$t('OrderFoodRecord.FilterPointTypeCash'),
              value: true
            }
          ]
        },
        {
          label: this.$t('OrderFoodRecord.FilterLabelStatus'),
          name: 'status',
          type: 'radio',
          value: '',
          options: [
            {
              label: this.$t('OrderFoodRecord.FilterStatusVoid'),
              value: true
            }, {
              label: this.$t('OrderFoodRecord.FilterStatusDone'),
              value: false
            }
          ]
        }
      ]
      window.addEventListener('scroll', this.scrollToLoad, true)
    } catch (err) {
      console.log(err)
    }
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.scrollToLoad, true)
  },
  methods: {
    closeVoidDialog () {
      this.selectedNote = null
      this.voidForm.noteInputValue = ''
      this.voidDialog = false
    },
    closeVoidInfoDialog () {
      this.voidInfoDialog = false
    },
    closeVoidResultDialog () {
      this.voidResultDialog = false
    },
    confirmVoid () {
      this.$refs.voidFormRef.validate(valid => {
        if (valid) {
          this.voidConfirmDialog = true
          this.isScrollToBottom = false
          this.$nextTick(() => {
            const scrollable = this.$refs.confirmContent
            const maxHeight = parseInt(window.getComputedStyle(scrollable).maxHeight, 10)
            if (scrollable.scrollHeight <= maxHeight) {
              this.isScrollToBottom = true
            } else {
              scrollable.scrollTop = 0
            }
          })
        }
      })
    },
    exportRecord () {
      const filterData = this.$refs.filter.selectedValue
      let startDateTime, endDateTime
      if (filterData.dateRadio === '1') {
        // 依日期
        startDateTime = dayjs(filterData.dateDate[0]).format('YYYY-MM-DD')
        endDateTime = dayjs(filterData.dateDate[1]).format('YYYY-MM-DD')
      } else if (filterData.dateRadio === '2') {
        // 依月分
        startDateTime = dayjs(filterData.dateDate[0]).startOf('month').format('YYYY-MM-DD')
        endDateTime = dayjs(filterData.dateDate[1]).endOf('month').format('YYYY-MM-DD')
      }
      // 匯出參數
      const params = {
        startDateTime,
        endDateTime,
        ...(filterData.household && { tabletId: filterData.household.TabletId }),
        ...(filterData.user && { storeUser: filterData.user }),
        ...(filterData.status !== undefined && { voidStatus: filterData.status }),
        ...(filterData.pointType !== undefined && { cashStatus: filterData.pointType })
      }

      apiOrderFoodNew.exportPointTableFood(params, { responseType: 'blob' }).then(res => {
        this.$downloadFile(res.data, `${decodeURIComponent(res.headers['content-disposition'].split(';')[2].replace(/"/g, '').replace("filename*=UTF-8''", '')).trim()}`)
      })
    },
    firstSearch () {
      const today = new Date()
      const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1)
      this.filter = {
        startDateTime: dayjs(firstDayOfMonth).format('YYYY-MM-DD'),
        endDateTime: dayjs(today).format('YYYY-MM-DD')
      }

      this.fetchOrderResult()
    },
    formatRecords (records) {
      if (records) {
        return records.replaceAll('\n', '<br/>')
      } else {
        return ''
      }
    },
    async fetchOrderResult () {
      try {
        if (this.scrollEnd || this.loading) return

        this.loading = true

        const params = {
          ...this.filter,
          offset: this.offset,
          maxCount: this.maxCount
        }
        const res = await apiOrderFoodNew.getPointTableFoodList(convertKeysToPascalCase(params))
        const datas = res.data.Data.PointTableFoods
        this.totalCount = res.data.Data.TotalCount
        if (datas.length < this.maxCount) {
          this.scrollEnd = true
        }
        this.offset += this.maxCount
        await this.$sleep(300)
        this.orderRecords = [...this.orderRecords, ...datas.map(item => {
          return {
            ...item,
            TransferAt: dayjs(item.TransferAt).format('YYYY-MM-DD HH:mm')
          }
        })]
        return true
      } catch (error) {
        console.log(error)
        return false
      } finally {
        this.loading = false
      }
    },
    async getVoidNoteTemplates () {
      try {
        const res = await apiOrderFood.getVoidNoteTemplates()
        this.noteTemplates = res.data.Data?.NoteTemplates
      } catch (error) {
        console.log(error)
      }
    },
    onNoteSelectChange (value) {
      this.voidForm.noteInputValue = value
    },
    onSearch (data) {
      console.log('onSearch', data)
      this.offset = 0
      this.scrollEnd = false
      this.orderRecords = []
      if (data) {
        // 依月份查詢把結束月份設為當月最後一天
        if (data.dateRadio === '2') {
          data.dateDate[1] = new Date(data.dateDate[1].getFullYear(), data.dateDate[1].getMonth() + 1, 0)
        }
        this.filter = {
          startDateTime: dayjs(data.dateDate[0]).format('YYYY-MM-DD'),
          endDateTime: dayjs(data.dateDate[1]).format('YYYY-MM-DD'),
          voidStatus: data.status, // 作廢狀態
          cashStatus: data.pointType, // 點數類型
          storeUser: data.user, // 結單人員
          tabletId: data.household && data.household.TabletId // 戶號
        }
      }
      this.fetchOrderResult()
    },
    prevStep () {
      this.voidConfirmDialog = false
    },
    async printAllPrinters (data) {
      try {
        const printerRes = await apiPoint.getCommunityPrinters()
        const printers = printerRes.data.Data.Printers
        const promiseArr = printers.map(el => printThermalPrinter(1, el.Ip, data))
        // 每台出單機都需要回傳出單結果
        const res = await Promise.allSettled(promiseArr)
        printers.forEach((el, index) => {
          el.IsFulfilled = res[index].status === 'fulfilled'
          el.Result = res[index].status === 'fulfilled' ? '列印成功' : '出單機列印失敗，請聯絡業務'
        })
        return printers
      } catch (error) {
        console.log(error)
      }
    },
    async rePrint ({ Id, TabletNote, TransferPoint, PointAfter, StoreUser }) {
      const loading = this.$loading({
        lock: true,
        text: '處理中，請稍候',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      try {
        const detailRes = await apiOrderFoodNew.getPointTableFoodDetail(Id)
        const orderingRecord = detailRes.data.Data
        const orderingList = orderingRecord.Commodities.map(item => ({
          name: item.Name,
          quantity: item.Quantity,
          price: item.Price
        }))
        const receiptObj = {
          userId: TabletNote,
          item: orderingList,
          pointBefore: TransferPoint * 1 + PointAfter * 1,
          staff: StoreUser,
          date: dayjs(orderingRecord.CreateAt).format('YYYY-MM-DD HH:mm')
        }
        const res = await this.printAllPrinters(receiptObj)
        this.printersWithStatusAndResult = res
        this.$refs.rePrintResultDialog.setVal(this.printersWithStatusAndResult)
      } catch (error) {
        console.log(error)
      } finally {
        loading.close()
      }
    },
    // 顯示補單按鈕提示內容
    showRePrintTooltip ({ VoidStatus, IsTableFoodForm }) {
      let content = ''
      // 如果是新版訂單
      if (IsTableFoodForm) {
        content = this.$t('OrderFoodRecord.NewVersionRecordActionTip', { Action: this.$t('OrderFoodRecord.RePrint') })
      } else {
        content = VoidStatus ? this.$t('OrderFoodRecord.VoidTip') : this.$t('OrderFoodRecord.OvertimeReprintTip')
      }
      return content
    },
    scrollToConfirm () {
      const scrollable = this.$refs.confirmContent
      // 由於放大縮小會有小數點誤差，所以用小於1來判斷是否在底部
      const isAtBottom =
        Math.abs(scrollable.scrollHeight - scrollable.scrollTop - scrollable.clientHeight) < 1
      if (isAtBottom) {
        this.isScrollToBottom = true
      }
    },
    async scrollToLoad () {
      this.$handleScrollWithLoading(this.fetchOrderResult)
    },
    showVoidInfo ({ VoidUser, VoidAt, VoidNote, ReceiptRecord }) {
      this.voidInfoDialog = true
      this.voidInfo = {
        receiptRecord: this.formatRecords(ReceiptRecord),
        voidNote: VoidNote,
        voidAt: dayjs(VoidAt).format('YYYY-MM-DD HH:mm'),
        voidUser: VoidUser
      }
    },
    voidOrder ({ Id, TransferPoint, TabletNote, ReceiptRecord }) {
      this.voidDialog = true
      this.voidOrderDetail = {
        id: Id,
        transferPoint: TransferPoint,
        tabletNote: TabletNote,
        receiptRecord: this.formatRecords(ReceiptRecord)
      }
    },
    async voidSubmit () {
      const params = {
        note: this.voidForm.noteInputValue
      }
      try {
        await apiOrderFoodNew.voidPointTableFood(this.voidOrderDetail.id, convertKeysToPascalCase(params))
        this.orderResult = {
          message: `訂單已作廢，交易點數 ${this.voidOrderDetail.transferPoint} 點已回補至 ${this.voidOrderDetail.tabletNote}。訂單作廢原因已同步更新至「點數回補備註」`,
          note: this.voidForm.noteInputValue,
          detail: this.voidOrderDetail.receiptRecord
        }
        this.voidResultDialog = true
        this.offset = 0
        this.orderRecords = []
        this.scrollEnd = false
        await this.fetchOrderResult()
      } catch (error) {
        console.log(error)
      } finally {
        this.selectedNote = null
        this.voidForm.noteInputValue = ''
        this.voidConfirmDialog = false
        this.voidDialog = false
      }
    }
  }
}
  </script>

  <style lang="scss" scoped>
  .order-record {
    @include mainLayer();
    .subtitle {
      display: flex;
      align-items: center;
      margin-top: 2rem;
      margin-bottom: 1rem;
      i {
        margin-right: 5px;
      }
    }
    .filter {
      margin-bottom: 2rem;
      .title {
        font-weight: bold;
        background-color: #ecefee;
        color: #333;
      }
      .el-col {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #ccc;
        height: 100px;
      }
    }

    .data-table {
      &__title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: left;
        margin-top: 2rem;
        margin-bottom:1rem;
        i {
          margin-right: 0.5rem;
        }
      }
      &__count{
        margin-right:.5rem;
      }
      &__void{
        text-decoration: underline;
        cursor: pointer;
        color:$warnColor
      }
    }

    .operate {
      display: flex;
      .reprint-btn {
        margin-left:10px
      }
    }

    ::v-deep .el-table{
      @include basicTable;
      &__body a.el-button--default.is-plain{
        color: #333
      }
    }

    ::v-deep .void-dialog{
      @include basicDialog;
      &__header{
        display: flex;
        align-items: center;
      }
      &__title{
        margin-right:.5rem
      }
      i{
        font-size: map-get($fontSize,large);
        color:$mainColor
      }
      &__form{
       .el-form-item,.el-select{
        width: 100%;
       }
      }
    }

    ::v-deep  .void-confirm-dialog{
      @include basicDialog;
      &__content{
        max-height:300px;
        overflow-y: scroll;
      }
      &__note,&__detail{
        display: flex;
        font-weight: bold;
        width: 100%;
        line-height: 2rem;
        :nth-child(1){
          width:30%;
        }
        :nth-child(2){
          width: 70%;
        }
      }
      &__note{
        padding-bottom:1rem;
        border-bottom: $lightFontColor 1px solid;
        margin-bottom:1rem;
      }
    }

    ::v-deep .void-result-dialog{
      @include basicDialog;
      &__point,&__tablet{
        color:$warnColor
      }
      &__note,&__detail,&__message{
        display: flex;
        font-weight: bold;
        width: 100%;
        line-height: 2rem;
        :nth-child(1){
          width:30%;
        }
        :nth-child(2){
          width: 70%;
        }
      }
      &__note,&__message{
        padding-bottom:1rem;
        border-bottom: $lightFontColor 1px solid;
        margin-bottom:1rem;
      }
    }

    ::v-deep .void-info-dialog{
      @include basicDialog;
      &__time,&__detail,&__note,&__user{
        display: flex;
        font-weight: bold;
        width: 100%;
        line-height: 2rem;
        :nth-child(1){
          width:30%;
        }
        :nth-child(2){
          width: 70%;
        }
      }
      &__note,&__time,&__user{
        padding-bottom:1rem;
        border-bottom: $lightFontColor 1px solid;
        margin-bottom:1rem;
      }
    }
  }
  </style>
